var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrowRight = function SvgArrowRight(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    fill: "none",
    transform: "rotate(180)",
    viewBox: "0 0 16 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "M6.875 12.625 1.25 7m0 0 5.625-5.625M1.25 7h13.5"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowRight);
export default ForwardRef;